module.exports = __webpack_public_path__ + "img/9788908043848.c0704718.jpg";